import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import file01 from '../assets/pdf/extract-of-annual-return/2015.03.31-MGT-9-Extract-of-Annual-Return.pdf'
import file02 from '../assets/pdf/extract-of-annual-return/2016.03.31_MGT-9-Extract-of-Annual-Return.pdf'
import file03 from '../assets/pdf/extract-of-annual-return/2017.03.31_MGT-9-Extract-of-Annual-Return.pdf'
import file04 from '../assets/pdf/extract-of-annual-return/2018.03.31-MGT-9-Extract-of-Annual-Return.pdf'
import file05 from '../assets/pdf/extract-of-annual-return/2019.03.31-MGT-9-Extract-of-Annual-Return.pdf'
import file06 from '../assets/pdf/extract-of-annual-return/2020.03.31-MGT-9-Extract-of-Annual-Return.pdf'


const ExtractOfAnnualReturn = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Extract of Annual Return | Investors | Statue of Belief</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Extract of Annual Return</li>
        </ul>
        <h1>Extract of Annual Return</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <h2 class="mb-3">Extract of Annual Return</h2>
        <ul className='list-item'>
            <li><a href={file01} download>2015.03.31-MGT-9 Extract of Annual Return</a></li>
            <li><a href={file02} download>2016.03.31_MGT-9 Extract of Annual Return</a></li>
            <li><a href={file03} download>2017.03.31_MGT-9 Extract of Annual Return</a></li>
            <li><a href={file04} download>2018.03.31-MGT-9 Extract of Annual Return</a></li>
            <li><a href={file05} download>2019.03.31-MGT-9 Extract of Annual Return</a></li>
            <li><a href={file06} download>2020.03.31-MGT-9 Extract of Annual Return</a></li>
        </ul>
    </Container>
    </section>
    <Footer />
    </div>
  );
};

export default ExtractOfAnnualReturn;